// ** React Imports
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import FormHelperText from '@mui/material/FormHelperText'
import {
    Autocomplete,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Fab,
} from '@mui/material'

import { useNavigate } from "react-router-dom";
import { Controller, useForm } from 'react-hook-form'
import axios from 'axios'
import Swal from 'sweetalert2'

import Icon from '../../../../components/icon';
import apiUrl from '../../../../configs/constant';
import { SyntheticEvent, useEffect, useState } from 'react';
import appInfo from '../../../../configs/app-info';
import { getDoctag, getGudang } from '../../../../api/helper';
import MsiDatagrid from '../../../../components/custom/MsiDatagridAuto';

export default function Add() {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token
    const cabang = JSON.parse(localStorage.getItem('cabang')!)
    const navigate = useNavigate();

    const [valDoctag, setValDoctag] = useState<any>(null)
    const [listDoctag, setListDoctag] = useState<any[]>([])

    const [valGudang, setValGudang] = useState<any>(null)
    const [listGudang, setListGudang] = useState<any[]>([])
    const [listWO, setListWO] = useState<any[]>([])
    const [openDialog, setOpenDialog] = useState<boolean>(false)

    interface FormInputs {
        syscabang_id: any,
        sysdoctag_id: any,
        mmgudang_id: any,
        tgl: any,
        keterangan: any,
        pic: any,
        wo_order_id: any
    }

    const defaultValues = {
        syscabang_id: cabang,
        tgl: new Date(new Date().getTime() + (7 * 60 * 60 * 1000)).toISOString().substring(0, 16),
    }

    const {
        control,
        handleSubmit,
        setValue,
        formState: { errors }
    } = useForm<FormInputs>({ defaultValues })

    useEffect(() => {
        const fetchDoctag = async () => {
            const response = await getDoctag(appInfo.menuId.usage, cabang, token);
            if (response.length > 0 && response.length === 1) {
                setValDoctag(response[0].nama)
                setValue('sysdoctag_id', response[0].id)
            }
            setListDoctag(response);
        };
        const fetchGudang = async () => {
            const response = await getGudang(token);
            setListGudang(response);
        };
        fetchDoctag();
        fetchGudang();
    }, [])

    const handleChangeAutocompleteDoctag = (event: SyntheticEvent, newValue: any | null) => {
        setValue('sysdoctag_id', newValue ? newValue.id : null)
        setValDoctag(newValue.nama)
    }
    const handleChangeAutocompleteGudang = (event: SyntheticEvent, newValue: any | null) => {
        setValue('mmgudang_id', newValue ? newValue.id : null)
        setValGudang(newValue.nama)
    }
    const onSubmit = (data: any) => {
        const submitProcess = () => {
            Swal.fire({
                title: 'Now loading',
                allowEscapeKey: false,
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading()
                }
            });

            const url = apiUrl.apiUrl + '/mm/usage/add';
            axios
                .post(url, data, {
                    headers: { Authorization: `Bearer ${token}` }
                })
                .then(response => {
                    if (response.data.success) {
                        Swal.fire({
                            title: 'Pemberitahuan',
                            text: response.data.message,
                            icon: 'success',
                            timer: 1000,
                            timerProgressBar: true,
                            willClose: () => {
                                navigate('/mm/usage/detail/' + response.data.data);
                            }
                        });
                    } else {
                        Swal.fire({
                            title: 'Pemberitahuan',
                            text: response.data.message,
                            icon: 'error'
                        });
                    }
                })
                .catch(error => {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: error.message,
                        icon: 'error'
                    });
                });
        };


        // ====== KONDISI BARU: jika ada WO maka minta persen ======
        if (data.wo_order_id) {
            data.progress_percent = 50;
            submitProcess();
            // Swal.fire({
            //     title: 'Progress Pengerjaan (%)',
            //     text: 'Masukkan persentase penyelesaian Work Order',
            //     input: 'number',
            //     inputAttributes: {
            //         min: 1,
            //         max: 100,
            //         step: '1'
            //     },
            //     inputPlaceholder: 'Contoh: 50',
            //     showCancelButton: true,
            //     confirmButtonText: 'Lanjutkan'
            // } as any).then(result => {
            //     if (!result.isConfirmed) return;

            //     const persen = Number(result.value);

            //     if (isNaN(persen) || persen < 1 || persen > 100) {
            //         Swal.fire({
            //             icon: 'error',
            //             title: 'Input tidak valid',
            //             text: 'Persentase harus antara 1 sampai 100'
            //         });
            //         return;
            //     }

            //     // masukkan persen ke data sebelum submit
            //     data.progress_percent = persen;

            //     // lanjut ke konfirmasi simpan
            //     Swal.fire({
            //         title: 'Konfirmasi',
            //         text: 'Apakah anda ingin menyimpan data ini ?',
            //         icon: 'question',
            //         showCancelButton: true,
            //         confirmButtonText: 'Simpan'
            //     }).then(resultConfirm => {
            //         if (resultConfirm.isConfirmed) {
                        
            //         }
            //     });
            // });
        }

        // ====== TANPA WO: langsung konfirmasi simpan ======
        else {
            Swal.fire({
                title: 'Konfirmasi',
                text: 'Apakah anda ingin menyimpan data ini ?',
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Simpan'
            }).then(result => {
                if (result.isConfirmed) {
                    submitProcess();
                }
            });
        }
    };


    const getWO = () => {
        const url = apiUrl.apiUrl + '/mm/usage/list-wo'
        axios.get(url, {
            params: {},
            headers: { Authorization: `Bearer ${token}` }
        })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListWO(data)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    const rowClickWO = (e: any) => {
        const data = e.data
        setValue('wo_order_id', data?.id)
        setOpenDialog(false)
    }

    const convertComponent = [
        {
            key: 'link',
            minWidth: 300,
            renderCell: ({ row }: any) => {
                const url = row.data?.link;
    
                if (!url) {
                    return <span style={{ color: "#999" }}>Tidak ada gambar</span>;
                }
    
                const openImage = () => {
                    Swal.fire({
                        title: 'Preview Gambar',
                        imageUrl: url,
                        imageWidth: 400,     // atur ukuran gambar
                        imageHeight: 'auto',
                        imageAlt: 'Preview',
                        showCloseButton: true,
                        showConfirmButton: false,
                        background: '#f9f9f9',
                        didClose: () => {
                            setOpenDialog(true);
                        }
                    });
                };
    
                return (
                    <img
                        src={url}
                        alt="Preview"
                        style={{
                            height: "120px",
                            width: "auto",
                            objectFit: "contain",
                            borderRadius: "8px",
                            cursor: "pointer",
                        }}
                        onClick={(e: React.MouseEvent<HTMLImageElement>) => {
                            e.stopPropagation(); // cegah rowClick
                            setOpenDialog(false);
                            openImage()
                        }}
                    />
                );
            }
        }
    ];

    return (
        <Grid container spacing={6} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xl={12} md={12} xs={12}>
                <Fab variant='extended' color='primary' sx={{ '& svg': { mr: 1 } }} onClick={() => window.history.back()}>
                    <Icon icon='mdi:arrow-left' />
                    Kembali
                </Fab>
                <div className={'content-block dx-card'} style={{ paddingRight: 20, paddingLeft: 20, paddingBottom: 10, paddingTop: 10 }}>
                    <Typography variant='h5' sx={{ textAlign: 'center' }}>
                        Buat Usage
                    </Typography>
                    <Divider sx={{ m: 0 }} />
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Grid container spacing={3} sx={{ mt: 1 }}>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Autocomplete
                                        value={valDoctag}
                                        options={listDoctag}
                                        id='doctag'
                                        isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                        onChange={handleChangeAutocompleteDoctag}
                                        renderOption={(props: any, option: any) => {
                                            return (
                                                <li {...props} key={option.id}>
                                                    {option.nama}
                                                </li>
                                            )
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                required
                                                label='Document'
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Autocomplete
                                        value={valGudang}
                                        options={listGudang}
                                        id='gudang'
                                        isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                        onChange={handleChangeAutocompleteGudang}
                                        renderOption={(props: any, option: any) => {
                                            return (
                                                <li {...props} key={option.id}>
                                                    {option.nama}
                                                </li>
                                            )
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                required
                                                label='Gudang'
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='tgl'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                type='datetime-local'
                                                value={value}
                                                label='Tanggal'
                                                onChange={onChange}
                                                InputLabelProps={{ shrink: true }}
                                                error={Boolean(errors.tgl)}
                                            />
                                        )}
                                    />
                                    {errors.tgl && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Tanggal harus diisi</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='pic'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='PIC'
                                                onChange={onChange}
                                                error={Boolean(errors.pic)}
                                            />
                                        )}
                                    />
                                    {errors.pic && (
                                        <FormHelperText sx={{ color: 'error.main' }}>PIC harus diisi</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} md={5} sm={5}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='wo_order_id'
                                        control={control}
                                        render={({ field: { value } }) => (
                                            <TextField
                                                label='ID WO'
                                                type='text'
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                                InputProps={{
                                                    readOnly: true,
                                                }}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={1} sm={1} sx={{ display: 'flex', alignItems: 'center' }}>
                                <Fab color='info' size='medium' onClick={() => {
                                    getWO();
                                    setOpenDialog(true);
                                }}
                                >
                                    <Icon icon='mdi:search' fontSize={35} color='white' />
                                </Fab>
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='keterangan'
                                        control={control}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='Keterangan'
                                                onChange={onChange}
                                                multiline
                                                rows={4}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Box
                                    sx={{
                                        width: '100%',
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                >
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', mt: 4 }}>
                                        <Button variant='contained' type='submit'
                                        >
                                            SIMPAN
                                        </Button>
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>
                    </form>
                </div>
            </Grid>

            <Dialog
                maxWidth={'xl'}
                fullWidth={true}
                open={openDialog}
                onClose={() => setOpenDialog(false)}
                aria-labelledby='form-dialog-title'
            >
                <DialogTitle id='form-dialog-title'>
                    <Typography variant='body1' sx={{ fontWeight: 500, mb: 1.5, color: '#212121' }}>
                        List WO
                    </Typography>
                </DialogTitle>
                <DialogContent dividers sx={{ p: 4 }}>
                    <Grid container spacing={4}>
                        <MsiDatagrid array={listWO} rowClick={rowClickWO} hiddenColumns={['id']} customRender={convertComponent}  />
                    </Grid>
                </DialogContent>
                <DialogActions className='dialog-actions-dense'>
                    <Button onClick={() => setOpenDialog(false)}>Batal</Button>
                </DialogActions>
            </Dialog>
        </Grid>
    )
}
function showToast(message: any, arg1: string) {
    throw new Error('Function not implemented.');
}

